import React from 'react'

const InvoiceAlreadyPaid = () => {
  return (
    <div className="row mt-5">
      <div className="col-12 text-center">
        <h1>Fakturan är redan betald!</h1>
      </div>
    </div>
  )
}

export default InvoiceAlreadyPaid
